// Local calendar date as YYYY-MM-DD.
// NEVER use toISOString() for this: it converts to UTC first, so any
// evening in a negative-offset timezone rolls over to tomorrow.
export function todayLocal(d = new Date()) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

// Whole days between two YYYY-MM-DD dates (b - a). Positive = b is later.
export function daysBetween(a, b = todayLocal()) {
  const d1 = new Date(a + 'T00:00:00')
  const d2 = new Date(b + 'T00:00:00')
  return Math.round((d2 - d1) / 86400000)
}
